<div class="drilldown-chart-no-data-container" [ngClass]="size">
  <mat-icon
    svgIcon="database-banned"
    class="drilldown-chart-no-data-icon"
    [ngClass]="size"
  ></mat-icon>
  <div class="drilldown-chart-no-data-text-container">
    <div>
      <span class="drilldown-chart-no-data-title">Data unavailable</span>
    </div>
    <div>
      <span class="drilldown-chart-no-data-subtitle"
        >We're currently unable to load the data.<br />
        Please try again later.</span
      >
    </div>
  </div>
</div>
